<template>
	<div class="container">
		<div class="sub_top">
			<div class="top_content">
				<div class="headline">
					<h2 class="sub_title">
						{{ $t('rtr_personal-how-qr.title1') }}<br />
						{{ $t('rtr_personal-how-qr.title2') }}
					</h2>
					<p class="sub_text">
						{{ $t('rtr_personal-how-qr.text1') }}<br />{{
							$t('rtr_personal-how-qr.text2')
						}}<br />{{ $t('rtr_personal-how-qr.text3') }}
					</p>
					<div class="button_area">
						<button
							class="button_bg_red mr_10"
							@click="$router.push({ name: 'auth-register' })"
						>
							{{ $t('button.signup') }}
						</button>
						<button
							class="button_bg_black"
							@click="$router.push({ name: 'auth-login' })"
						>
							{{ $t('auth.login_btn') }}
						</button>
					</div>
				</div>
			</div>
		</div>
		<section>
			<div class="sub_content2">
				<p class="catch_text">
					{{ $t('rtr_personal-how-qr.text4') }}
				</p>
				<div class="section01">
					<div class="d_flex justify_center">
						<div class="rectangle_w">
							<div>
								<div>
									<img
										src="@/assets/images/sub/qr_rectangle_01.png"
										alt=""
										class="mb_20"
									/>
								</div>
								<p class="title_bold">
									{{ $t('rtr_personal-how-qr.text5') }}
								</p>
								<p class="text02">
									{{ $t('rtr_personal-how-qr.text6') }}<br />{{
										$t('rtr_personal-how-qr.text7')
									}}
								</p>
							</div>
						</div>
						<div class="rectangle_w">
							<div>
								<div>
									<img
										src="@/assets/images/sub/qr_rectangle_02.png"
										alt=""
										class="mb_20"
									/>
								</div>
								<p class="title_bold">
									{{ $t('rtr_personal-how-qr.text8') }}
								</p>
								<p class="text02">
									{{ $t('rtr_personal-how-qr.text9') }}<br />{{
										$t('rtr_personal-how-qr.text10')
									}}<br />{{ $t('rtr_personal-how-qr.text11') }}
								</p>
							</div>
						</div>
						<div class="rectangle_w">
							<div>
								<div>
									<img
										src="@/assets/images/sub/qr_rectangle_03.png"
										alt=""
										class="mb_20"
									/>
								</div>
								<p class="title_bold">
									{{ $t('rtr_personal-how-qr.text12') }}
								</p>
								<p class="text02">
									{{ $t('rtr_personal-how-qr.text13') }}<br />{{
										$t('rtr_personal-how-qr.text14')
									}}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section>
			<div class="sub_content qr">
				<div class="d_flex">
					<div class="sub_1">
						<p class="text mb_50">
							{{ $t('rtr_personal-how-qr.text15') }}<br />
							<span class="fc_red fw_bold">{{
								$t('rtr_personal-how-qr.text16')
							}}</span
							>{{ $t('rtr_personal-how-qr.text17') }}
						</p>
						<div class="text">
							<input
								class="radio_tab"
								type="radio"
								name="tab_group"
								id="tab1"
								value="tab1"
								v-model="showTab"
							/><label for="tab1"
								><span class="qr_underline">{{
									$t('rtr_personal-how-qr.text18')
								}}</span></label
							>
							<input
								class="radio_tab"
								type="radio"
								name="tab_group"
								id="tab2"
								value="tab2"
								v-model="showTab"
							/><label for="tab2"
								><span class="qr_underline">{{
									$t('rtr_personal-how-qr.text19')
								}}</span></label
							>
							<input
								class="radio_tab"
								type="radio"
								name="tab_group"
								id="tab3"
								value="tab3"
								v-model="showTab"
							/><label for="tab3"
								><span class="qr_underline">{{
									$t('rtr_personal-how-qr.text20')
								}}</span></label
							>
						</div>
					</div>
					<div class="sub_2">
						<div class="sub_2_img_area">
							<img src="@/assets/images/sub/qr_02.png" alt="" />
							<div class="step_img" v-show="this.showTab === 'tab1'">
								<img src="@/assets/images/sub/qr_03.png" alt="" />
							</div>
							<div class="step_img" v-show="this.showTab === 'tab2'">
								<img src="@/assets/images/sub/qr_03.png" alt="" />
								<div class="scan"><span></span></div>
							</div>
							<div class="step_three_img" v-show="this.showTab === 'tab3'">
								<img src="@/assets/images/sub/qr_04.png" alt="" />
							</div>
						</div>
						<div class="description">
							<div class="step one" v-show="this.showTab === 'tab1'">
								<div>
									{{ $t('rtr_personal-how-qr.text21') }}
									{{ $t('rtr_personal-how-qr.text22') }}
									{{ $t('rtr_personal-how-qr.text23') }}
									<span class="qr_bar"></span>
								</div>
							</div>
							<div class="step two" v-show="this.showTab === 'tab2'">
								{{ $t('rtr_personal-how-qr.text24')
								}}<span class="qr_bar"></span>
							</div>
							<div class="step three" v-show="this.showTab === 'tab3'">
								{{ $t('rtr_personal-how-qr.text25')
								}}<span class="qr_bar"></span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section>
			<div class="sub_bottom_background">
				<div class="sub_bottom_background_content">
					<div class="headline">
						<h2 class="sub_title">
							{{ $t('rtr_personal-how-qr.title3') }}<br />{{
								$t('rtr_personal-how-qr.title4')
							}}
						</h2>
						<p class="sub_text">
							{{ $t('rtr_personal-how-qr.text26') }}<br />{{
								$t('rtr_personal-how-qr.text27')
							}}<br />{{ $t('rtr_personal-how-qr.text28') }}
						</p>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: 'Qr',
	data() {
		return {
			showTab: 'tab1',
		};
	},
};
</script>
<style scoped></style>
